<template>
    <div class="col-md-6 border-0">
        <div class="ibox dasboard_graph dashboard_dough">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution">
                <div class="clearfix">
                    <div class="left_container">
                        <ul class="title_list">
                            <li class="title-text">AIT Submission</li>
                        </ul>
                    </div>
                    <div class="right_container">
                        <template v-if="$fiscal_years && $fiscal_years.length > 0">
                            <b-form-select class="dasboard_graph_select" v-model="search_doughnut.fiscal_year"
                                @change="setSearchDoughnut()">
                                <option value="null">Select Fiscal Year</option>
                                <option v-for="fyear in $fiscal_years" :value="fyear" :key="fyear">{{ fyear }}</option>
                            </b-form-select>
                        </template>
                    </div>
                </div>
            </div>
            <div class="ibox-content pt-0">
                <template v-if="loader">
                    <div class="trz_loader text-center py-5">
                        {{ load_data }}
                        <br />
                        <img :src="pageurl + '/images/download-loader.svg'" class="loader-logo text-center mt-2"
                            width="60px" />
                    </div>
                </template>
                <template v-else-if="doughnutDatas != null">
                    <div class="chart-container-wrapper row d-flex align-items-center">
                        <div class="col-md-6">
                            <div class="chart-container pie-chart dashboard_dough_grapg">
                                <doughnut-chart :chart-data="doughnutDatas" :options="options_doughnut"
                                    :styles="myStyles_doughnut" class="pb-3"></doughnut-chart>
                            </div>
                        </div>
                        <div class="col-md-6 text-left">
                            <div class="analysis-blocks-wrapper">
                                <div class="analysis-blocks d-flex align-items-center mb-2 p-2 rounded">
                                    <div class="analysis-blocks-circle" :style="{ backgroundColor: '#3A52A5' }"></div>
                                    <div class="analysis-blocks-contents align-items-center">
                                        <div class="tile"><span>Total Active Employees</span></div>
                                        <div class="value"><span>{{ total_active }}</span></div>
                                    </div>
                                </div>
                                <div class="analysis-blocks d-flex align-items-center mb-2 p-2 rounded cursor-pointer hover-bg"
                                    @click="openModal('Submitted')">
                                    <div class="analysis-blocks-circle" :style="{ backgroundColor: '#BAEDBD' }"></div>
                                    <div class="analysis-blocks-contents align-items-center">
                                        <div class="tile"><span>Submitted AIT</span></div>
                                        <!-- <div class="value"><span>{{ submitted }} ({{ submittedPercentage }}%)</span></div> -->
                                        <div class="value"><span>{{ submitted }}</span></div>
                                    </div>
                                </div>
                                <div class="analysis-blocks d-flex align-items-center mb-2 p-2 rounded cursor-pointer hover-bg"
                                    @click="openModal('Not Submitted')">
                                    <div class="analysis-blocks-circle" :style="{ backgroundColor: '#C6C7F8' }"></div>
                                    <div class="analysis-blocks-contents align-items-center">
                                        <div class="tile"><span>Not Submitted AIT</span></div>
                                        <!-- <div class="value"><span>{{ not_submitted }} ({{ notSubmittedPercentage }}%)</span></div> -->
                                        <div class="value"><span>{{ not_submitted }}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <!-- Details Modal -->
        <b-modal id="ait-details-modal"
            :title="search_doughnut.fiscal_year && search_doughnut.fiscal_year !== 'null' ? `AIT - Submission Details ${search_doughnut.fiscal_year}` : 'AIT - Submission Details'"
            size="xl" hide-footer>
            <b-overlay :show="download_loading || export_loading" rounded="sm"> <!--Afrin: added 8-3-26-->
                <div class="ibox-content p-0">
                    <div class="row mb-3">
                        <div class="col-md-12 d-flex justify-content-start align-items-center">
                            <div class="mr-2">
                                <b-button class="btn btn-primary custom-wizard-btn" @click="exportTemplate">
                                    <b-icon icon="download" class="mr-2"></b-icon> Export
                                </b-button>
                            </div>
                            <div class="mr-2">
                                <b-button class="btn btn-primary custom-wizard-btn" @click="openImportModal">
                                    <b-icon icon="upload" class="mr-2"></b-icon> Import
                                </b-button>
                            </div>
                            <div class="mr-2">
                                <b-button class="btn btn-success custom-wizard-btn" @click="downloadTableExcel">
                                    <b-icon icon="download" class="mr-2"></b-icon> Download
                                </b-button>
                            </div>
                            <div class="mr-2" v-if="modal_status_filter == 'Not Submitted'">
                                <b-button class="btn btn-primary custom-wizard-btn"
                                    @click="requestDocuments('other-documents')">
                                    <b-icon icon="journals" class="mr-2"></b-icon> Request Document
                                </b-button>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3 align-items-center">
                        <div class="col-md-6 align-self-center">
                            <div class="custom-search">
                                <b-input-group>
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search" v-model="modal_search"
                                        @input="modal_current_page = 1"></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                        <div class="col-md-6 d-flex justify-content-end align-items-center">
                            <b-button id="filter_button_ait" class="btn btn-primary custom-wizard-btn"
                                v-b-toggle.sidebar_right_ait>
                                <b-icon class="mr-2" icon="funnel-fill"></b-icon>Filter
                            </b-button>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped table-hover dataTable border">
                            <thead>
                                <tr class="table-head">
                                    <th style="text-align: center;">
                                        <input type="checkbox" v-model="checkAll">
                                    </th>
                                    <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)"
                                        :class="[modal_sort_by == column.name ? (modal_sort_desc ? 'sorting_desc' : 'sorting_asc') : 'sorting', 'custom-label']"
                                        style="cursor: pointer;" :style="column.style">
                                        <span>{{ column.label }}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in paginatedDetails" :key="item.employee_id">
                                    <td style="text-align: center;">
                                        <input type="checkbox" v-model="selected_employees" :value="item.employee_id">
                                    </td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.employee_code }}</td>
                                    <td>{{ item.department }}</td>
                                    <td>{{ item.fiscal_year }}</td>
                                    <td style="text-align: right;">{{ formatMoney(item.amount) }}</td>
                                    <td style="text-align: center;">
                                        <span
                                            :class="['status-msg', item.status == 'Submitted' ? 'status-success' : 'status-warning']">
                                            {{ item.status }}
                                        </span>
                                    </td>
                                </tr>
                                <tr v-if="paginatedDetails.length == 0">
                                    <td colspan="7" class="text-center py-3">No matching records found.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                    <!-- alpha fix- chnaged pagination style  -->
                    <div class="row py-2 no-margin" v-if="paginatedDetails.length > 0">

                        <div class="col-md-12 p-0 no-margin">

                            <ul class="pagination b-pagination float-left mb-0 mt-1">

                                <li class="page-item disabled m-2">
                                    View
                                </li>

                                <li class="page-item disabled">

                                    <b-form-select v-model="modal_per_page" :options="[
                                        { value: 20, text: '20' },
                                        { value: 50, text: '50' },
                                        { value: 100, text: '100' }
                                    ]" @change="modal_current_page = 1">
                                    </b-form-select>

                                </li>

                                <li class="page-item disabled m-2">
                                    per page. Total {{ filteredDetails.length }} records found.
                                </li>

                            </ul>

                            <b-pagination v-model="modal_current_page" :total-rows="filteredDetails.length"
                                :per-page="modal_per_page" hide-goto-end-buttons class="float-right mt-1">

                                <template #prev-text>
                                    <span>Previous</span>
                                </template>

                                <template #next-text>
                                    <span>Next</span>
                                </template>

                            </b-pagination>

                        </div>

                    </div>
                </div>
            </b-overlay> <!--Afrin: added 8-3-26 end-->

            <b-sidebar id="sidebar_right_ait" title="Filter" right shadow>
                <filter-list :key="sidebar_key" :company_options="company_options" :search_by_filter="search_by_filter"
                    :default_column="default_column" :column_selected="column_selected"
                    v-on:childToParent="filterList"></filter-list>
            </b-sidebar>
        </b-modal>

        <!-- Import Modal -->
        <b-modal id="ait-import-modal" title="Bulk Import AIT" hide-footer>
            <div class="ibox-content p-3">
                <div class="row mb-3">
                    <div class="col-sm-12 text-muted">
                        Download the bulk import template and import AIT(s) accordingly.
                    </div>
                </div>
                <b-overlay :show="modal_import_loading" rounded="sm" class="mt-2 custom-overlay">
                    <b-form-file v-model="import_file" placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..." @change="handleImportFile"
                        accept=".xlsx,.xls"></b-form-file>

                    <div v-if="import_errors && import_errors.length > 0" class="mt-3">
                        <div class="alert alert-danger mb-2">Total errors: {{ import_errors.length }}</div>
                        <ul class="list-group" style="max-height: 200px; overflow-y: auto;">
                            <li class="list-group-item list-group-item-danger py-2"
                                v-for="(error, index) in import_errors" :key="index">
                                {{ error }}
                            </li>
                        </ul>
                    </div>
                </b-overlay>
            </div>
        </b-modal>

        <!-- Request Document Modal -->
        <b-modal id="bv-modal-request_docement" hide-footer title="Request Document"
            v-if="selected_employees.length > 0">
            <request-docements :employee_ids="selected_employees" :request_document_type="request_document_type"
                v-on:childToParent="sendRequestDocumentMail"></request-docements>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['payrunsfiscalyear', 'pageurl'],
    data() {
        return {
            search_doughnut: { fiscal_year: '' },
            doughnutDatas: null,
            options_doughnut: null,
            myStyles_doughnut: null,
            total_active: 0,
            submitted: 0,
            not_submitted: 0,
            loader: false,
            load_data: 'Generating AIT Dashboard...',
            export_loading: false, //Afrin: added 8-3-26
            download_loading: false, //Afrin: added 8-3-26

            // Modal variables
            columns: [
                { label: 'Employee Name', name: 'name' },
                { label: 'Employee Code', name: 'employee_code' },
                { label: 'Department', name: 'department' },
                { label: 'Fiscal Year', name: 'fiscal_year' },
                { label: 'Amount', name: 'amount', style: 'text-align: right;' },
                { label: 'Status', name: 'status', style: 'text-align: center;' }
            ],
            details: [],
            modal_search: '',
            modal_status_filter: 'All',
            modal_dept_filter: 'All',
            modal_per_page: 20,
            modal_current_page: 1,
            modal_sort_by: 'name',
            modal_sort_desc: false,
            selected_employees: [],
            import_file: null,
            modal_import_loading: false,
            import_errors: [],
            decimal_setting: 'yes',
            request_document_type: '',
            search_by_filter: {
                name: '',
                employee_code: '',
                department_id: []
            },
            company_options: [],
            default_column: ['name', 'employee_code', 'department'],
            column_selected: [],
            sidebar_key: 0
        };
    },
    computed: {
        // submittedPercentage() {
        //     if (this.total_active == 0) return 0;
        //     return ((this.submitted / this.total_active) * 100).toFixed(1);
        // },
        // notSubmittedPercentage() {
        //     if (this.total_active == 0) return 0;
        //     return ((this.not_submitted / this.total_active) * 100).toFixed(1);
        // },
        departments() {
            let depts = this.details.map(item => item.department).filter(Boolean);
            let uniqueDepts = [...new Set(depts)].sort();
            return ['All', ...uniqueDepts];
        },
        checkAll: {
            get() {
                if (this.filteredDetails.length == 0) return false;
                return this.selected_employees.length == this.filteredDetails.length;
            },
            set(value) {
                if (value) {
                    this.selected_employees = this.filteredDetails.map(item => item.employee_id);
                } else {
                    this.selected_employees = [];
                }
            }
        },
        filteredDetails() {
            let list = this.details;

            // Status Filter
            if (this.modal_status_filter && this.modal_status_filter !== 'All') {
                list = list.filter(item => item.status == this.modal_status_filter);
            }

            // Department Filter from sidebar
            if (this.search_by_filter && this.search_by_filter.department_id && this.search_by_filter.department_id.length > 0) {
                let deptNames = [];
                let deptOpt = this.company_options.find(opt => opt.label === 'department');
                if (deptOpt && deptOpt.options) {
                    deptNames = deptOpt.options
                        .filter(opt => this.search_by_filter.department_id.includes(opt.id))
                        .map(opt => opt.name.toLowerCase());
                }
                if (deptNames.length > 0) {
                    list = list.filter(item => item.department && deptNames.includes(item.department.toLowerCase()));
                }
            }

            // Name and Code Filter from sidebar
            if (this.search_by_filter) {
                if (this.search_by_filter.name) {
                    let nameLower = this.search_by_filter.name.toLowerCase();
                    list = list.filter(item => item.name && item.name.toLowerCase().includes(nameLower));
                }
                if (this.search_by_filter.employee_code) {
                    let codeLower = this.search_by_filter.employee_code.toLowerCase();
                    list = list.filter(item => item.employee_code && item.employee_code.toLowerCase().includes(codeLower));
                }
            }

            // Search Filter
            if (this.modal_search) {
                let searchLower = this.modal_search.toLowerCase();
                list = list.filter(item => {
                    return (
                        (item.name && item.name.toLowerCase().includes(searchLower)) ||
                        (item.employee_code && item.employee_code.toLowerCase().includes(searchLower)) ||
                        (item.department && item.department.toLowerCase().includes(searchLower)) ||
                        (item.status && item.status.toLowerCase().includes(searchLower))
                    );
                });
            }

            // Sorting
            if (this.modal_sort_by) {
                let sortBy = this.modal_sort_by;
                let desc = this.modal_sort_desc;
                list = list.slice().sort((a, b) => {
                    let valA = a[sortBy];
                    let valB = b[sortBy];

                    if (sortBy == 'amount') {
                        valA = parseFloat(valA) || 0;
                        valB = parseFloat(valB) || 0;
                    } else {
                        valA = valA ? valA.toString().toLowerCase() : '';
                        valB = valB ? valB.toString().toLowerCase() : '';
                    }

                    if (valA < valB) return desc ? 1 : -1;
                    if (valA > valB) return desc ? -1 : 1;
                    return 0;
                });
            }

            return list;
        },
        paginatedDetails() {
            let start = (this.modal_current_page - 1) * this.modal_per_page;
            let end = start + this.modal_per_page;
            return this.filteredDetails.slice(start, end);
        }
    },
    watch: {
        'search_by_filter.department_id': function (newVal) {
            if (newVal && newVal.length === 1) {
                let deptId = newVal[0];
                let deptOpt = this.company_options.find(opt => opt.label === 'department');
                if (deptOpt && deptOpt.options) {
                    let matched = deptOpt.options.find(opt => opt.id === deptId);
                    if (matched) {
                        this.modal_dept_filter = matched.name;
                        return;
                    }
                }
            }
            this.modal_dept_filter = 'All';
        }
    },
    methods: {
        setSearchDoughnut() {
            this.getAitStat();
        },
        doughnutData(submitted, not_submitted) {
            this.doughnutDatas = {
                labels: ['Submitted AIT', 'Not Submitted AIT'],
                datasets: [{
                    data: [submitted, not_submitted],
                    borderColor: ['#BAEDBD', '#C6C7F8'],
                    backgroundColor: ['#BAEDBD', '#C6C7F8'],
                    borderWidth: 5,
                    borderRadius: 10,
                    spacing: 10,
                    offset: 10,
                    hoverOffset: 4
                }]
            };

            this.options_doughnut = {
                responsive: true,
                maintainAspectRatio: true,
                cutoutPercentage: 85,
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        title: (tooltipItem, data) => {
                            return data['labels'][tooltipItem[0]['index']];
                        },
                        label: (tooltipItem, data) => {
                            return data['datasets'][0]['data'][tooltipItem['index']].toLocaleString();
                        },
                    },
                }
            };

            this.myStyles_doughnut = {
                height: '100%',
                width: '100%',
                position: 'relative',
            };
        },
        getAitStat() {
            this.loader = true;
            axios.get(this.pageurl + '/dashboard/ait-stat', {
                params: {
                    fiscal_year: this.search_doughnut.fiscal_year
                }
            }).then(response => {
                if (response.data) {
                    this.total_active = response.data.total_active;
                    this.submitted = response.data.submitted;
                    this.not_submitted = response.data.not_submitted;

                    this.doughnutData(this.submitted, this.not_submitted);
                }
                this.loader = false;
            }).catch(error => {
                console.error("Error fetching AIT stats:", error);
                this.loader = false;
            });
        },
        openModal(status) {
            this.modal_status_filter = status;
            this.modal_dept_filter = 'All';
            if (this.search_by_filter) {
                this.search_by_filter.name = '';
                this.search_by_filter.employee_code = '';
                this.search_by_filter.department_id = [];
            }
            this.modal_search = '';
            this.modal_current_page = 1;
            this.selected_employees = [];
            this.export_loading = false; //Afrin: added 8-3-26
            this.download_loading = false; //Afrin: added 8-3-26
            this.$bvModal.show('ait-details-modal');
            this.fetchDetails();
        },
        filterList(value) {
            this.modal_current_page = 1;
            this.search_by_filter = value.search_by_filter;
            if (value.reset == 1) {
                this.$root.$emit('bv::toggle::collapse', 'sidebar_right_ait');
            }
        },
        getCompanyOptions() {
            axios.get(this.pageurl + '/employee/list')
                .then(response => {
                    if (response.data && response.data.options) {
                        this.company_options = response.data.options;
                    }
                })
                .catch(error => {
                    console.error("Error fetching company options:", error);
                });
        },
        fetchDetails() {
            axios.get(this.pageurl + '/dashboard/ait-stat', {
                params: {
                    fiscal_year: this.search_doughnut.fiscal_year,
                    get_details: 1
                }
            }).then(response => {
                if (response.data && response.data.details) {
                    this.details = response.data.details;
                }
            }).catch(error => {
                console.error("Error fetching AIT breakdown details:", error);
            });
        },
        sortBy(field) {
            if (this.modal_sort_by == field) {
                this.modal_sort_desc = !this.modal_sort_desc;
            } else {
                this.modal_sort_by = field;
                this.modal_sort_desc = false;
            }
            this.modal_current_page = 1;
        },
        exportTemplate() {
            this.export_loading = true; // Afrin: added 8-3-26
            let formData = new FormData();
            formData.append('flg', 2);
            formData.append('employee_status', 1);

            axios.post(this.pageurl + '/employee/export-for-update', formData)
                .then(response => {
                    var fileURL = response.data;
                    this.downloadFileContent(fileURL);
                    this.export_loading = false; //Afrin: added 8-3-26
                })
                .catch(error => {
                    console.error("Error exporting template:", error);
                    this.export_loading = false; //Afrin: added 8-3-26
                });
        },
        downloadTableExcel() {
            // this.loader = true; // Afrin: removed 8-3-26
            this.download_loading = true; // Afrin: added 8-3-26
            axios.post(this.pageurl + '/dashboard/ait-stat/export', {
                fiscal_year: this.search_doughnut.fiscal_year,
                status: this.modal_status_filter,
                department: this.modal_dept_filter,
                search: this.modal_search,
                sort_by: this.modal_sort_by,
                sort_desc: this.modal_sort_desc
            }).then(response => {
                var fileURL = response.data;
                this.downloadFileContent(fileURL);
                // this.loader = false; // Afrin: removed 8-3-26
                this.download_loading = false; //Afrin: added 8-3-26
            }).catch(error => {
                console.error("Error downloading excel:", error);
                // this.loader = false; // Afrin: removed 8-3-26
                this.download_loading = false; //Afrin: added 8-3-26
            });
        },
        openImportModal() {
            this.import_file = null;
            this.modal_import_loading = false;
            this.import_errors = [];
            this.$bvModal.show('ait-import-modal');
        },
        handleImportFile(event) {
            let file = event.target.files[0];
            if (!file) return;

            this.modal_import_loading = true;
            this.import_errors = [];

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            };
            const data = new FormData();
            data.append('empfile', file);
            data.append('type', 'ait');

            axios.post(this.pageurl + '/employee/import/data', data, config)
                .then(response => {
                    this.$bvToast.toast('Data feed file successfully imported', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });
                    this.modal_import_loading = false;
                    this.import_file = null;
                    this.$bvModal.hide('ait-import-modal');
                    this.fetchDetails();
                    this.getAitStat();
                })
                .catch(error => {
                    this.modal_import_loading = false;
                    this.import_file = null;

                    let msg = 'Please correct the data and try again. There might be any non well formed numeric value encountered.';
                    if (error.response && error.response.data && error.response.data.errors) {
                        this.import_errors = Array.isArray(error.response.data.errors)
                            ? error.response.data.errors
                            : Object.values(error.response.data.errors).flat();
                    }

                    this.$bvToast.toast(msg, {
                        title: `Data Template Error`,
                        variant: 'danger',
                        solid: true
                    });
                });
        },
        get_decimal_settings() {
            axios.get(this.pageurl + '/decimal-settings')
                .then(response => {
                    this.decimal_setting = response.data;
                })
                .catch(error => {
                    console.error("Error fetching decimal settings:", error);
                });
        },
        formatMoney(amount) {
            let money = Number(amount);
            if (isNaN(money)) return amount;

            if (this.decimal_setting == 'yes' || this.decimal_setting == '') {
                return money.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            } else {
                return Math.round(money).toLocaleString();
            }
        },
        requestDocuments(type) {
            if (this.selected_employees.length == 0) {
                this.$bvToast.toast("No employee selected", {
                    title: 'Warning!',
                    variant: 'warning',
                    solid: true,
                    toaster: "b-toaster-top-right"
                });
            } else {
                this.request_document_type = type;
                this.$bvModal.show('bv-modal-request_docement');
            }
        },
        sendRequestDocumentMail() {
            this.$bvToast.toast('Email sending initiated. Receiver(s) should receive email soon.', {
                title: 'Success',
                variant: 'success',
                solid: true
            });
        }
    },
    created() {
        this.get_decimal_settings();
        this.getCompanyOptions();
        this.search_doughnut.fiscal_year = this.getCurrentFinancialYear();
        this.getAitStat();
    }
}
</script>
